export default __webpack_public_path__ + "static/media/Abel.c70a08a6.jpg";